var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSharearrow = function SvgSharearrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78111 9.23455L8.01183 15.2962C8.10651 15.7698 8.57986 16.0776 9.05322 15.9829C9.33723 15.9355 9.57391 15.7224 9.69225 15.462L15.9169 1.25495C16.1299 0.805063 15.9169 0.28414 15.4672 0.071035C15.2305 -0.0236783 14.9702 -0.0236783 14.7335 0.071035L0.532804 6.32212C0.0831154 6.51154 -0.129895 7.03247 0.0831155 7.48235C0.201455 7.74282 0.438132 7.93224 0.722146 8.00328L6.78111 9.23455ZM13.3844 2.6283L9.19522 12.218L8.39052 8.3111C8.31952 7.95592 8.0355 7.69546 7.70415 7.62442L3.82263 6.84304L13.3844 2.6283Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSharearrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sharearrow.0f2361e0.svg";
export { ForwardRef as ReactComponent };